<template>
	<div class="order-body">
		<div class="fx-header">
			<p>批量代客下单</p>
		</div>
		<Search :ids="ids" :needauditingflag='needauditingflag' :customList="customList" :lineList="lineList" :active="active" :clddock="clddock" :clearing="clearing" :AuthorityList='AuthorityList' ref='searchRef' @modifySuc="modifySuc" @handleSearch="handleSearch" @exportExcel="exportExcel"/>
		<MainTable
			:clddock="clddock"
			:backorderdock="backorderdock"
			:active="active"
			:size='size'
			:page='page'
			:orderSort='orderSort'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			:needauditingflag='needauditingflag'
			:canundeliveredunpaysendflag='canundeliveredunpaysendflag'
			@saveSelect='saveSelect'
			@modifySuc="modifySuc"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
	</div>
</template>

<script>
import Search from '@/components/batchValet/Search.vue'
import MainTable from '@/components/batchValet/MainTable.vue'
export default {
	name: 'batchValet',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			shopOptions: [],
			sellerShopId: '',
			AuthorityList: {
				'07_0007_0001_00': false
			},
			active: '全部订单',
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			buyerTel: '',
			orderNumber: '',
			keyword: '',
			paymentMode: '-1',
			acceptMode: '-1',
			cancelMode: '-1',
			ordersource: '-1',
			pushstate: '-1',
			liquidateflag: '-1',
			buyerName: '',
			orderStatus: -1,
			isSellerpull: false,
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			isCancel: false,
			tabParams: {},
			clearing: '0',
			totalOrderCount: 0,
			clddock: 0,
			backorderdock: 0,
			origin: '',
			excelParams: {},
			ids: [],
			dateType: 3,
			needauditingflag: false,
			canundeliveredunpaysendflag: false,
			customList: [],
			lineList: [],
			customerAccount: '',
			customerCategoryId: '0',
			lineId: '0',
			address: '',
			productName: '',
			customerName: '',
			orderSort: '',
			afterSaleNumber: '',
			afterSaleTypeId: '',
			deptId: '',
			dealTypeId: '',
			memo: '',
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '6-7')
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.getCategory()
		this.getAuthority('07_0007_0000_00')
		this.openPage()
	},
	methods: {
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				dateValue: this.dateValue,
				customerAccount: this.customerAccount,
				customerCategoryId: this.customerCategoryId,
				customerName: this.customerName
				// page: this.page,
				// size: this.size
			}
			window.sessionStorage.setItem('batchValetSelect', JSON.stringify(params))
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		openPage () {
			if (window.sessionStorage.getItem('batchValetSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('batchValetSelect'))
				this.dateValue = data.dateValue
				this.customerAccount = data.customerAccount
				this.customerCategoryId = data.customerCategoryId
				this.customerName = data.customerName
				// this.page = data.page
				// this.size = data.size
			}
			this.findOrderList()
		},
		modifySuc () {
			this.openPage()
		},
		shopChange () {
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			tabParams.sellerShopId = this.sellerShopId
			this.shopOptions.forEach(item => {
				if (this.sellerShopId === item.shopId) {
					tabParams.organid = item.organid
				}
			})
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
			this.findCount()
			this.findOrderList()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.dateValue = data.dateValue
			this.customerAccount = data.customerAccount
			this.customerCategoryId = data.customerCategoryId
			this.customerName = data.customerName
			this.page = 1
			this.excelParams = {
				beginDate: window.sessionStorage.getItem('afterSearchTime') ? JSON.parse(window.sessionStorage.getItem('afterSearchTime'))[0] : this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: window.sessionStorage.getItem('afterSearchTime') ? JSON.parse(window.sessionStorage.getItem('afterSearchTime'))[1] : this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				customerAccount: data.customerAccount,
				customerCategoryId: data.customerCategoryId,
				customerName: data.customerName
			}
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findOrderList()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/exportAfterSaleOrder`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = '售后记录详情数据(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		getSystemSet () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					this.needauditingflag = res.needauditingflag
					this.canundeliveredunpaysendflag = res.canundeliveredunpaysendflag
					resolve(res)
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						this.clearing = res.data.clearing
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findOrderList () {
			this.tableData = []
			let params = {
				beginDate: (window.sessionStorage.getItem('afterSearchTime') ? JSON.parse(window.sessionStorage.getItem('afterSearchTime'))[0] : this.dateValue.length > 0 ? this.dateValue[0] : ''),
				endDate: (window.sessionStorage.getItem('afterSearchTime') ? JSON.parse(window.sessionStorage.getItem('afterSearchTime'))[1] : this.dateValue.length > 0 ? this.dateValue[1] : ''),
				page: this.page,
				size: this.size,
				customerCategoryId: this.customerCategoryId,
				customerAccount: this.customerAccount,
				customerName: this.customerName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replaceorder/list`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				res.recordList = res.recordList || []
				res.recordList.forEach(e => {
					e.finalprice = this.$fxUtils.toFixedSHW(e.finalprice, 2)
					e.totalprice = this.$fxUtils.toFixedSHW(e.totalprice, 2)
				})
				this.tableData = res.recordList
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.menu-box {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
